// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__VdNOs","tab__icon":"Tab_tab__icon__fPTwP","tab__text":"Tab_tab__text__j9L8u","tab__tooltip":"Tab_tab__tooltip__f-qK8","active":"Tab_active__qSFgf"};